import {api} from "../api";
import {breadcrumbsWithoutName} from "../utils/string";
import {getISOZonedDateTime, Temporal} from "@/shared/utils/datefunctions";
import {Task} from "@/shared/timr";


export const EVENT_RECOMMENDED_TASK_SELECTED = "recommended.task.selected";

export async function loadAndDisplayRecommendedTasks<TEventSource = HTMLElement>(
	eventContainer: JQuery<TEventSource>,
	recommendedTasksContainer: JQuery,
	recentTasksContainer: JQuery,
	referenceDate?: Temporal.ZonedDateTime,
	projectTimeCount: boolean = true	// default value 1 to load recommended tasks
): Promise<boolean> {
	const deferred = $.Deferred<boolean>();

	function fillContainer(container: JQuery, tasks: Task[], sparkles: boolean = false, scores?: number[]) {
		const minScoreToPassAsRecommendation = 0.1;
		container.empty();
		for (let i = 0; i < tasks.length; i++) {
			const task = tasks[i];
			// DEVNOTE: As for now, leave recommended tasks with score below 0.1 in the response, but don't display them
			// in case that we want to debug something quickly, we can still see them in the console (TIMR-7741)
			if (scores && scores[i] < minScoreToPassAsRecommendation) {
				continue;
			}
			const taskPanel = $("<div>")
				.addClass("panel panel-task")
				.addClass(task.billable ? "border-BILLABLE" : "border-NOT_BILLABLE")
				.data({"task-id": task.id})
				.append($("<div>")
					.addClass("panel-border")
					.append($("<div>")
						.addClass("display-flex justify-content-space-between flex-valign-middle")
						.append($("<div>")
							.text(task.name)
							.addClass("panel-title"))
						.append($("<div>")
							.addClass(sparkles ? "sparkles" : "fal fa-clock text-grey-600 text-size-small")))
					.append($("<div>")
						.html(breadcrumbsWithoutName(task.breadCrumbs, task.name))
						.addClass("panel-body-no-padding text-muted")));

			// Add click listener
			taskPanel.on("click", e => {
				eventContainer.triggerHandler(EVENT_RECOMMENDED_TASK_SELECTED, [task, $(e.currentTarget)]);
			});

			if (sparkles) {
				taskPanel.find(".sparkles").popover({
					trigger: "hover",
					template: '<div class="popover popover-task" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
					delay: 400,
					placement: "bottom",
					container: "body",
					content: messages["taskTree.recommended.tooltip"]
				});
			} else {
				taskPanel.find(".fa-clock").popover({
					trigger: "hover",
					template: '<div class="popover popover-task" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
					delay: 400,
					placement: "bottom",
					container: "body",
					content: messages["taskTree.recent.tooltip"]
				});
			}
			container.append(taskPanel);
		}
		container.toggle(container.children().length > 0);
	}

	// Add six placeholder tasks with loading animation
	const tasksSection = recommendedTasksContainer.closest("[data-tasks-section]");
	if (projectTimeCount) {
		tasksSection.show();
		recentTasksContainer.empty();
		recommendedTasksContainer.empty().show()
			.append($("<div>").addClass("panel panel-task loading"))
			.append($("<div>").addClass("panel panel-task loading"))
			.append($("<div>").addClass("panel panel-task loading"));

		api("tasks/getRecommendedTasks.json")
			.get({referenceDate: getISOZonedDateTime(referenceDate ?? Temporal.Now.zonedDateTimeISO())})
			.done(data => {
				const hasData = data?.recommendedTasks && data.recentTasks && (data.recommendedTasks.length > 0 || data.recentTasks.length > 0);
				tasksSection.toggle(hasData);
				tasksSection.siblings("[data-tasks-dropdown-column]")
					.toggleClass("col-xs-12", !hasData)
					.toggleClass("col-xs-8", hasData);
				if (hasData) {
					fillContainer(recommendedTasksContainer, data.recommendedTasks, true, data.scores);
					fillContainer(recentTasksContainer, data.recentTasks, false);
				}
				deferred.resolve(hasData);
			});
	} else {
		// don't show task section
		tasksSection.hide();
		tasksSection.siblings("[data-tasks-dropdown-column]")
			.toggleClass("col-xs-12", true)
			.toggleClass("col-xs-8", false);
		deferred.resolve(false);
	}
	return deferred.promise();
}
